var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1162 530L1162 558",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1162.5,
    cy: 525.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.99 525.19C1157.99 521.283 1161.29 518.117 1165.36 518.117C1165.94 518.117 1166.51 518.184 1167.06 518.308C1165.74 517.48 1164.19 517 1162.52 517C1157.81 517 1154 520.806 1154 525.5C1154 530.194 1157.81 534 1162.52 534C1164.81 534 1166.89 533.093 1168.43 531.62C1167.49 532.032 1166.45 532.263 1165.36 532.263C1161.29 532.263 1157.99 529.096 1157.99 525.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.4 524.6L1171.37 522.146L1169.54 523.719L1167.3 523.056L1168.11 525.337L1166.77 527.381L1169.1 527.218L1170.5 529.144L1171.13 526.763L1173.34 525.909L1171.4 524.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.0b4c74f4dde0b800fecf2ec0dcac46a3.svg";
export { ForwardRef as ReactComponent };